import { COUNTRY } from '@/config';

const PASSWORD_GENERATOR_URL_BY_BRAND = {
  br: 'https://www.hostgator.com.br/gerador-de-senhas',
  mx: 'https://www.hostgator.mx/generador-de-contrasenas',
  co: 'https://www.hostgator.co/generador-de-contrasenas',
  cl: 'https://www.hostgator.cl/generador-de-contrasenas',
  ar: 'https://www.hostgator.ar/generador-de-contrasenas',
  pe: 'https://www.hostgator.pe/generador-de-contrasenas',
  bo: 'https://www.hostgator.bo/generador-de-contrasenas',
  cr: 'https://www.hostgator.cr/generador-de-contrasenas',
  do: 'https://www.hostgator.do/generador-de-contrasenas',
  ec: 'https://www.hostgator.net.ec/generador-de-contrasenas',
  sv: 'https://www.hostgator.sv/generador-de-contrasenas',
  pa: 'https://www.hostgator.pa/generador-de-contrasenas',
  py: 'https://www.hostgator.com.py/generador-de-contrasenas',
  uy: 'https://www.hostgator.uy/generador-de-contrasenas',
};

export const PASSWORD_GENERATOR_URL = PASSWORD_GENERATOR_URL_BY_BRAND[COUNTRY];
